// extracted by mini-css-extract-plugin
export default {"burger":"Burger_burger__6AniM","_active":"Burger__active__GcUgF"};